import React from "react";
import { Switch, Route } from "react-router-dom";
import { FETCH_REGIONS } from "../regions/RegionTypes";
import { useRouteData } from "../redux/useRouteData";
import { EMsPanel } from "./EMsPanel";
import { EMForm } from "./EMForm";

const EMS_ROUTE_DATA = [
  FETCH_REGIONS,
];

export function EMsPage() {
  useRouteData(EMS_ROUTE_DATA);

  return (
    <Switch>
      <Route path="/administration/ems/:id" strict={true}>
        <EMForm />
      </Route>
      <Route exact path="/administration/ems/" strict={true}>
        <EMForm />
      </Route>
      <Route path="/administration/ems">
        <EMsPanel />
      </Route>
    </Switch>
  );
}
